import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui';

/**
 * Real 404 for unmatched routes.
 *
 * The catch-all used to `<Navigate to="/home" replace />`, which made every broken link look
 * like a deliberate trip to the dashboard. That hid genuine bugs — a nav item pointing at a
 * route that no longer existed silently "worked" for months. Showing the path that failed
 * makes a bad link self-reporting instead.
 */
const NotFoundPage: React.FC = () => {
  const location = useLocation();

  return (
    <div className="tw-flex tw-min-h-[60vh] tw-flex-col tw-items-center tw-justify-center tw-p-4 tw-text-center">
      <p className="tw-mb-2 tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wide tw-text-content-muted">
        Error 404
      </p>
      <h1 className="tw-mb-3 tw-text-2xl tw-font-semibold tw-text-content">
        We couldn&rsquo;t find that page
      </h1>
      <p className="tw-mb-1 tw-max-w-prose tw-text-content-secondary">
        Nothing is routed to this address. If you followed a link from inside WRAP, it is out of
        date — please report it so it can be fixed.
      </p>
      <p className="tw-mb-4 tw-max-w-full tw-break-all tw-font-mono tw-text-sm tw-text-content-muted">
        {location.pathname}
      </p>
      <Button as={Link} to="/home" variant="primary">
        Go to Home
      </Button>
    </div>
  );
};

export default NotFoundPage;
